import { Dispatch, useState } from 'react';
import { Button, Fade, Menu, MenuItem } from '@mui/material';
import CustomDialog from '@/components/Dialog/CustomDialog';
import SampleDataCount from './SampleDataCount';

interface BtnSelectSampleProps {
  handleAddSampleClick: (sampleCount: number) => void;
  setOpen: Dispatch<React.SetStateAction<boolean>>;
}

const BtnSelectSample = ({
  handleAddSampleClick,
  setOpen,
}: BtnSelectSampleProps) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogType, setDialogType] = useState<'count' | 'select'>('count');
  const [sampleCount, setSampleCount] = useState(1);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleSelect = () => {
    setDialogType('select');
    setDialogOpen(true);
    setAnchorEl(null);
    setOpen(true);
  };

  const handleCreate = () => {
    setDialogType('count');
    setDialogOpen(true);
    setAnchorEl(null);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleDialogSubmit = () => {
    if (dialogType === 'count') {
      handleAddSampleClick(sampleCount);
    } else if (dialogType === 'select') {
      // Logic for when dialogSelect is true
      console.log('Submit for Select Sample');
    }
    setDialogOpen(false);
  };

  const handleKeyDown = (
    event: React.KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevents the default form submission
      handleDialogSubmit();
    }
  };

  return (
    <div>
      <Button
        size="small"
        variant="outlined"
        id="fade-button"
        aria-controls={menuOpen ? 'fade-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={menuOpen ? 'true' : undefined}
        onClick={handleClick}
      >
        Browse sample
      </Button>
      <Menu
        id="fade-menu"
        MenuListProps={{
          'aria-labelledby': 'fade-button',
        }}
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        <MenuItem onClick={handleSelect}>Choose sample</MenuItem>
        <MenuItem onClick={handleCreate}>Create sample</MenuItem>
      </Menu>
      {dialogType === 'count' && (
        <CustomDialog
          open={dialogOpen}
          onClose={handleDialogClose}
          onSubmit={handleDialogSubmit}
          title="Samples"
        >
          <SampleDataCount
            setSampleCount={setSampleCount}
            sampleCount={sampleCount}
            handleKeyDown={handleKeyDown}
          />
        </CustomDialog>
      )}
    </div>
  );
};

export default BtnSelectSample;
